module.exports = __webpack_public_path__ + "img/fl01.cea15245.png";